import type { PmDoc, PmNode } from "@storytell/types/richText";
import { PmNodeType } from "@storytell/types/richText";

export interface QuoteExtraction {
  quote: string | undefined;
  contentWithoutQuote: PmDoc;
}

/**
 * Extracts quote from prompt richText if present.
 * Detects if first node is a blockquote and extracts it separately.
 */
export function extractQuoteFromPrompt(richText?: PmDoc): QuoteExtraction {
  if (!richText?.content || richText.content.length === 0) {
    return {
      quote: undefined,
      contentWithoutQuote: richText || { type: PmNodeType.Doc, content: [] },
    };
  }

  const firstNode = richText.content[0];
  if (firstNode.type === PmNodeType.Blockquote) {
    const quote = extractTextFromBlockquote(firstNode);

    const remainingContent = richText.content.slice(2);

    return {
      quote,
      contentWithoutQuote: {
        type: PmNodeType.Doc,
        content: remainingContent,
      },
    };
  }

  return { quote: undefined, contentWithoutQuote: richText };
}

function extractTextFromBlockquote(node: PmNode): string {
  if (node.type !== PmNodeType.Blockquote) return "";

  return node.content
    .map((childNode) => extractTextFromNode(childNode))
    .filter((text) => text.length > 0)
    .join("\n");
}

function extractTextFromNode(node: PmNode): string {
  if (node.type === PmNodeType.Paragraph) {
    return node.content?.map((inline) => (inline.type === PmNodeType.Text ? inline.text : "")).join("") || "";
  }
  return "";
}
